import { render, staticRenderFns } from "./ItemProfileParty.vue?vue&type=template&id=568a3af2&scoped=true"
import script from "./ItemProfileParty.vue?vue&type=script&lang=js"
export * from "./ItemProfileParty.vue?vue&type=script&lang=js"
import style0 from "./ItemProfileParty.vue?vue&type=style&index=0&id=568a3af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a3af2",
  null
  
)

export default component.exports